// extracted by mini-css-extract-plugin
module.exports = {"title":"thank-you_title__2-BQ0"};